module.exports = __webpack_public_path__ + "img/DSC_0072.d1c9b835.jpg";